// Action Types
export const DOCUMENT_MODE_CALCULATION = 'DOCUMENT_MODE_CALCULATION';
